import React, { cloneElement } from "react";
import { usePermissionGuardRedirect } from "../hooks/usePermissionGuard";

export default function PermissionsGate({
    children,
    RenderError = () => <></>,
    errorProps = null,
    scopes = [],
    routeCheck = false
}) {
    const permissionGranted = usePermissionGuardRedirect(scopes, () => routeCheck && !errorProps);

    // The permissions hasn't been fetched from the API yet if null:
    if (permissionGranted === null) {
        return null;
    }

    if (!permissionGranted && !errorProps) {
        return <RenderError />;
    }

    if (!permissionGranted && errorProps) {
        // NOTE: Only single-component as a children, not mutliple, otherwise it won't work:
        return cloneElement(children, { ...errorProps });
    }

    return <>{children}</>;
}
